// extracted by mini-css-extract-plugin
export default {"root":"HeaderLvl2_root__hxidJ","placeHolderShimmer":"HeaderLvl2_placeHolderShimmer__ep-vp"};